module.exports = __webpack_public_path__ + "static/img/__7806.7083a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7806.jpg
// module id = z7bd
// module chunks = 0